import React from 'react';
import CustomDatePicker from '../utils/CustomDatePicker';
import { ddmmToIso, isoToDdmm } from './formatlayicilar';

/**
 * Uygulamanın CustomDatePicker'ını ISO ('YYYY-MM-DD') sözleşmesine sarar.
 * (src/zamanasimi/TarihGirisi.js'teki desenin ISO sürümü.)
 *
 * onChange YALNIZCA tam+geçerli tarihte ISO, alan boşaltılınca '' yayar.
 * Kısmî/geçersiz girişte parent'a dokunulmaz; aksi halde parent değeri değişip
 * CustomDatePicker'ın value→localDate senkronu yazımı silerdi.
 *
 * maxDate (opsiyonel, Date): takvimden seçilebilen en geç tarih. Tebliğ alanı
 * varsayılanı (bugün) kullanır; gelecek yıl bayramı girişi ileri bir Date geçer.
 */
function TarihAlani({ valueIso, onChange, maxDate }) {
  const handleChange = (str) => {
    if (!str) {
      onChange('');
      return;
    }
    const iso = ddmmToIso(str); // 31/02 gibi geçersizler '' döner (bedava doğrulama)
    if (iso) onChange(iso);
  };

  return (
    <CustomDatePicker
      value={isoToDdmm(valueIso)}
      onChange={handleChange}
      onBlur={() => {}}
      maxDate={maxDate}
    />
  );
}

export default TarihAlani;
